/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadLoginVerifyRequest
 */
export interface UploadLoginVerifyRequest {
    /**
     * 
     */
    phone: string;
    /**
     * 
     */
    code: string;
}

/**
 * Check if a given object implements the UploadLoginVerifyRequest interface.
 */
export function instanceOfUploadLoginVerifyRequest(value: object): value is UploadLoginVerifyRequest {
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function UploadLoginVerifyRequestFromJSON(json: any): UploadLoginVerifyRequest {
    return UploadLoginVerifyRequestFromJSONTyped(json, false);
}

export function UploadLoginVerifyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadLoginVerifyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'code': json['code'],
    };
}

export function UploadLoginVerifyRequestToJSON(json: any): UploadLoginVerifyRequest {
    return UploadLoginVerifyRequestToJSONTyped(json, false);
}

export function UploadLoginVerifyRequestToJSONTyped(value?: UploadLoginVerifyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
        'code': value['code'],
    };
}

